import axios from "axios";
import md5 from "js-md5";
import Swal from "sweetalert2";
// import _ from "lodash";

class API {
  constructor() {
    this.token = "";
    if (localStorage.getItem("token")) {
      this.token = localStorage.getItem("token");
    }
  }

  get baseURL() {
    return process.env.VUE_APP_ENDPOINT;
  }

  set token(value) {
    this._token = value;
    this.instance = axios.create({
      baseURL: this.baseURL,
      timeout: 30000,
      headers: { Authorization: this._token }
    });
    this.instance.interceptors.response.use(
      res => res,
      error => {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        if (!!error.response && error.response.status === 403) {
          Swal.fire({
            icon: "error",
            title: "登入資訊已過期",
            text: "請重新登入"
          }).then(() => {
            window.location.href = "/login";
          });
        } else {
          return Promise.reject(error);
        }
      }
    );
  }

  login(data) {
    data.password = md5(data.password);
    return this.instance.post("api/auth/login", data);
  }

  createBanner(data) {
    return this.instance.post("api/banner/", data);
  }

  updateBanner(data) {
    return this.instance.put(`api/banner/${data.id}`, data);
  }

  getBanner(params) {
    return this.instance.get("api/banner/", { params });
  }

  removeBanner(id) {
    return this.instance.delete(`api/banner/${id}`);
  }

  createNews(data) {
    return this.instance.post("api/news/", data);
  }

  updateNews(data) {
    return this.instance.put(`api/news/${data.id}`, data);
  }

  getNewsList(params) {
    return this.instance.get("api/news/", { params });
  }

  removeNews(id) {
    return this.instance.delete(`api/news/${id}`);
  }

  createRank(data) {
    return this.instance.post("api/rank/", data);
  }

  getRankList(params) {
    return this.instance.get("api/rank/", { params });
  }

  updateRank(data) {
    return this.instance.put(`api/rank/${data.id}`, data);
  }

  removeRank(id) {
    return this.instance.delete(`api/rank/${id}`);
  }

  createTeacher(data) {
    return this.instance.post("api/teacher/", data);
  }

  getTeacherList(params) {
    return this.instance.get("api/teacher/", { params });
  }

  updateTeacher(data) {
    return this.instance.put(`api/teacher/${data.id}`, data);
  }

  removeTeacher(id) {
    return this.instance.delete(`api/teacher/${id}`);
  }

  createCourseSchedule(data) {
    return this.instance.post("api/course-schedule/", data);
  }

  getCourseList(params) {
    return this.instance.get("api/course-schedule/", { params });
  }

  updateCourseSchedule(data) {
    return this.instance.put(`api/course-schedule/${data.id}`, data);
  }

  removeCourseSchedule(id) {
    return this.instance.delete(`api/course-schedule/${id}`);
  }

  changePassword(data) {
    data.oldPassword = md5(data.oldPassword);
    data.newPassword = md5(data.newPassword);
    return this.instance.post(`api/auth/changepassword`, data);
  }
}

export default new API();
